module.exports = __webpack_public_path__ + "static/media/Naked.0ccf3acd.PNG";